// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3mn3i","paramInput":"JobSimulator_paramInput__dTpaV","input":"JobSimulator_input__2LZKL"};